$(function(){
    $("#hotel_checkInDate").pickadate({
        clear: false,
        today: false,
        min: new Date(),
        format: 'yyyy-mm-dd',
        formatSubmit: 'yyyy-mm-dd'
    });
});